import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view03ImageOptions } from './views/exterior_view03'

class XC38HullTreatment extends Component {
    constructor(props) {
        super(props);
        this.handleHullTreatmentChange = this.handleHullTreatmentChange.bind(this);
    }


    handleHullTreatmentChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullTreatment = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view03ImageOptions;


        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 1800, height: 785 }} transform={
                [
                    0.056133, -0.03055, 0, -0.000042,
                    0.078935, 0.039448, 0, 0.000034,
                    0, 0, 1, 0,
                    170, 240, 0, 1
                ]}>
                <ConfiguratorImage boat="XC38" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Hull Treatment' /></h1>

                    <p><Trans defaults='3 layers of sprayed epoxy primer & 2 layers of antifouling paint' /></p>

                    <RadioGroup label={this.props.t("Treatment options:")} options={this.props.hullTreatmentOptions} value={this.props.configuration.HullTreatment} onChange={this.handleHullTreatmentChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38HullTreatment);


// WEBPACK FOOTER //
// ./src/XC38/XC38HullTreatment.js